import './App.css';
import ThemeProvider from '../src/theme/ThemeProvider';
import {router} from './router';
import {RouterProvider} from 'react-router-dom';

import useEvent401Exception from './hooks/useEvent401Exception';

import useGlassixWidget from './hooks/useGlassixWidget';
function App() {
    useEvent401Exception();
    useGlassixWidget();
    return (
        <ThemeProvider>
            <RouterProvider router={router} />
        </ThemeProvider>
    );
}

export default App;
